import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import AlertName from './StepOneComponents/CreateAlert.StepOne.AlertName';
import ThirdParties from './../../reusable/Form/ThirdPartyRadioGroup';
import RiskAngleLevels from './StepOneComponents/CreateAlert.StepOne.RiskAngleLevels';
import createAlertApi from "./CreateAlertPage.api.js";
import xhr from "../../utils/xhr";
import SectionOnOffToggleWrapper from './SectionOnOffToggleWrapper';
import ExperianReportLevels from './StepOneComponents/CreateAlert.StepOne.ExperianReportLevels';
import reduxStore from '../../reduxStore';
import CategoriesEntitiesSelector from './../../reusable/Form/CategoriesEntitiesSelector';
import { SECTION_ENTITIES, SECTION_ALL_ENTITIES, SECTION_CATEGORIES } from "../../constants";
export const ALERT_NAME_VALIDATION_VALID = 'isValid';
export const ALERT_NAME_VALIDATION_INVALID = 'isInvalid';
export const ALERT_NAME_VALIDATION_LOADING = 'isLoading';

export default class StepOne extends Component {

    constructor(props) {
        super(props);

        this.state = {
            errorMessageAlertName: '',
            errorMessageEntities: '',
            errorMessageSliders: '',
            alertNameValidationIconsState: null,
            isContinueButtonEnabled: false
        };

        this.user = reduxStore.getState().user;

        this.toggleContinueButtonDisabled = this.toggleContinueButtonDisabled.bind(this);
        this.onThirdPartyChange = this.onThirdPartyChange.bind(this);
        this.validateAndProceedToStepTwo = this.validateAndProceedToStepTwo.bind(this);
        this.validateAlertNameSection = this.validateAlertNameSection.bind(this);
        this.resetAlertNameValidation = this.resetAlertNameValidation.bind(this);
        this.validateEntitiesSection = this.validateEntitiesSection.bind(this);
        this.resetEntitiesSectionValidation = this.resetEntitiesSectionValidation.bind(this);
        this.validateSliderLevels = this.validateSliderLevels.bind(this);
    }

    onThirdPartyChange(data) {
        this.props.saveData({
            thirdParty: data
        })
        this.resetEntitiesSectionValidation();
    }

    toggleContinueButtonDisabled(isContinueButtonEnabled) {
        this.setState({isContinueButtonEnabled: !isContinueButtonEnabled})
    }

    validateAndProceedToStepTwo() {
        this.validateAlertNameSection(this.props.data.name, () => {
            if (this.validateEntitiesSection() && this.validateSliderLevels()) {
                this.props.continue();
            }
        })
    }

    getValues() {
        switch (this.props.data.thirdParty.thirdPartySelection) {
            case SECTION_ALL_ENTITIES:
                return [];
            case SECTION_CATEGORIES:
                return this.props.data.thirdParty.selectedCategories
            case SECTION_ENTITIES:
                return this.props.data.thirdParty.selectedThirdPartiesIds
        }
    }

    validateAlertNameSection(inputValue, callback = null) {

        //do not validate if the alert name is empty
        if (!this.props.data.name) {
            this.toggleContinueButtonDisabled(true);
            return false;
        }

        this.setState({alertNameValidationIconsState: ALERT_NAME_VALIDATION_LOADING});
        createAlertApi.validateNameField(inputValue, this.props.data.alertId)
            .then((response) => {
                if (response.body === false) {
                    this.toggleContinueButtonDisabled(response.body);
                    this.setState({
                        errorMessageAlertName: '',
                        alertNameValidationIconsState: ALERT_NAME_VALIDATION_VALID
                    }, () => {
                        if (callback) callback()
                    });
                    return !response.body;
                }
                this.toggleContinueButtonDisabled(response.body);
                this.setState({
                    errorMessageAlertName: 'RSS_Add_Error_addRssFeed.feedInfo.unavailableNameError',
                    alertNameValidationIconsState: ALERT_NAME_VALIDATION_INVALID
                });
                return response.body;
            }).catch((error) => {
            xhr.handleAllErrors(error);
            console.log("********************** Alert Name Validation Failed ********************");
        });
    }

    resetAlertNameValidation() {
        this.setState({alertNameValidationIconsState: ''});
    }

    validateEntitiesSection() {
        switch (this.props.data.thirdParty.thirdPartySelection) {
            case 'specific-third-parties-section':
                if (this.props.data.thirdParty.selectedThirdPartiesIds.length > 0) {
                    this.setState({errorMessageEntities: ''});
                    return true;
                } else {
                    this.setState({errorMessageEntities: 'Alerts_Create_UIText_error.specificEntities'});
                    document.getElementsByClassName("add-rss-page")[0].scrollIntoView();
                    return false;
                }
            case 'categories-section':
                if (this.props.data.thirdParty.selectedCategories.length > 0) {
                    this.setState({errorMessageEntities: ''});
                    return true;
                } else {
                    this.setState({errorMessageEntities: 'Alerts_Create_UIText_error.specificCategories'});
                    document.getElementsByClassName("add-rss-page")[0].scrollIntoView();
                    return false;
                }
            default:
                this.setState({errorMessageEntities: ''});
                return true;
        }
    }

    resetEntitiesSectionValidation() {
        this.setState({errorMessageEntities: ''});
    }

    validateSliderLevels() {
        if (!this.props.data.isNewsAlertsActive) {
            return true;
        }
        if (this.props.data.riskAngles.political === 0 &&
            this.props.data.riskAngles.economic === 0 &&
            this.props.data.riskAngles.social === 0 &&
            this.props.data.riskAngles.technological === 0 &&
            this.props.data.riskAngles.legal === 0 &&
            this.props.data.riskAngles.environmental === 0) {
            this.setState({errorMessageSliders: 'Alerts_Create_UIText_error.riskAngles'});
            document.getElementsByClassName("risk-angles-levels")[0].scrollIntoView();
            return false;
        } else {
            this.setState({errorMessageSliders: ''});
            return true;
        }
    }

    render() {
        
        return (
            <div className="create-alert-page__step-one">

                <AlertName data={this.props.data}
                           saveData={this.props.saveData}
                           toggleContinueButtonDisabled={this.toggleContinueButtonDisabled}
                           validateAlertNameSection={this.validateAlertNameSection}
                           resetAlertNameValidation={this.resetAlertNameValidation}
                           alertNameValidationIconsState={this.state.alertNameValidationIconsState}
                           errorMessage={this.state.errorMessageAlertName}/>
                <div className="add-rss-page">
                    <div className='section-title'><FormattedMessage id='Alerts_Create_UIText_name.step1.entities.whichEntities'/></div>

                    <CategoriesEntitiesSelector section={this.props.data.thirdParty.thirdPartySelection}
                                                values={this.getValues()}
                                                onChange={this.onThirdPartyChange}
                                                allEntitiesMsgId={"Alerts_Create_UIText_name.step1.entities.all"}>
                        {this.state.errorMessageEntities &&
                            <div className="error-message"><FormattedMessage id={this.state.errorMessageEntities}/></div>}
                    </CategoriesEntitiesSelector>

                </div>

                <div className='section-title'>
                    <div><FormattedMessage id='Alerts_Create_UIText_name.step1.riskAnglesSection.whatContent'/></div>
                    <div className='disclaimer'>(<FormattedMessage id='Alerts_Create_UIText_name.step1.riskAnglesSection.whatContentDisclaimer'/>)</div>
                </div>

                <div className='section-title'><FormattedMessage id='Alerts_Create_UIText_name.step1.riskAnglesSection.newsAlerts'/></div>
                <SectionOnOffToggleWrapper isSectionActive={this.props.data.isNewsAlertsActive}
                                           saveData={this.props.saveData}
                                           saveDataField={'isNewsAlertsActive'}
                                           sectionId={'newsAlertsSection'}
                                           dottedBorder={true}>
                    <RiskAngleLevels data={this.props.data}
                                     saveData={this.props.saveData}
                                     validateSliderLevels={this.validateSliderLevels}
                                     errorMessage={this.state.errorMessageSliders} />
                </SectionOnOffToggleWrapper>

                <div className='section-title'><FormattedMessage id='Alerts_Create_UIText_name.step1.sanctionsAndWatchlistsSection'/></div>
                <SectionOnOffToggleWrapper isSectionActive={this.props.data.isSwActive}
                                           saveData={this.props.saveData}
                                           saveDataField={'isSwActive'}
                                           sectionId={'sanctionsAndWatchlistsSection'}
                                           dottedBorder={true}>

                    <div className="sanctions-disclaimer">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.sanctionsAndWatchlistsSection.disclaimer'/>
                    </div>

                </SectionOnOffToggleWrapper>

                {
                    this.user.appSettings.isExperianEnabled && (<div className='section-title'><FormattedMessage
                        id='Alerts_Create_UIText_name.step1.experianSection' /></div>)
                }
                {
                    this.user.appSettings.isExperianEnabled && (
                        <SectionOnOffToggleWrapper isSectionActive={this.props.data.isExperianActive}
                                                   saveData={this.props.saveData}
                                                   saveDataField={'isExperianActive'}
                                                   sectionId={'experianSection'}>
                            <ExperianReportLevels data={this.props.data}
                                                  saveData={this.props.saveData} />
                        </SectionOnOffToggleWrapper>)
                }

                <div className='navigation-buttons'>
                    <button type='button'
                            className='button-primary-lg continue'
                            disabled={!this.state.isContinueButtonEnabled}
                            onClick={this.validateAndProceedToStepTwo}>
                        <FormattedMessage id='General_CoreFunctionality_UIText_general.continue'/>
                    </button>
                    <button type='button'
                            className='button-secondary-lg cancel'
                            onClick={this.props.cancel}>
                        <FormattedMessage id='General_CoreFunctionality_UIText_general.cancel'/>
                    </button>
                </div>

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/CreateAlert.StepOne.jsx